/**
 * Gates the Redux devtools middleware in `createStore` to development builds:
 * in production it made zustand log "[zustand devtools middleware] Please
 * install/enable Redux devtools extension" in the browser console.
 * `process.env.NODE_ENV` is inlined by Next at build time, so this folds to a
 * constant `false` in production bundles. The `as true` cast only satisfies
 * `CreateStoreOptions`' literal `devtools: true` type — at runtime the option
 * is treated as a plain truthy flag.
 */
export const isDevtoolsEnabled = (process.env.NODE_ENV === 'development') as true;
